import * as React from "react";
import { Mutation } from "react-apollo";
import { Form, Label, FormGroup, Input, Button } from "reactstrap";
import styled from "@emotion/styled";

// GraphQL
import VerifyCustomerCodeMutation from "../../GraphQL/Mutations/VerifyCustomerCode";

// Presentation/UI
import { LogoText } from "../../Components/Text";
import Loader from "../../Components/Loader";

// Theme
import { Colors } from "../../Themes";

// Utils
import { CUSTOMER_VERIFIED } from "../../Utils/LocalStorage";

interface IProps {
  customerId: any;
  notification(message: string): void;
  updateView(): void;
}

interface IState {
  customerRequestCode: string;
  loading: boolean;
  error: null | string;
}

const Wrapper = styled.div`
  width: 400px;
  background: ${Colors.snow};
  border-radius: 4px;
  padding: 22px;
  box-shadow: 0 7px 14px 0 rgba(59, 65, 94, 0.1),
    0 3px 6px 0 rgba(0, 0, 0, 0.07);
`;

class CustomerRequestCodeForm extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      customerRequestCode: "",
      loading: false,
      error: null
    };
  }

  // Handle change
  handleChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { value }: { value: string } = e.currentTarget;
    this.setState({ customerRequestCode: value });
  };

  validateForm = (): boolean => {
    // Check for undefined or empty infput fields
    if (!this.state.customerRequestCode) {
      this.setError("Please enter your customer code");
      return false;
    }
    return true;
  };

  // Error
  setError = (error: string): void => {
    this.setState(
      {
        error
      },
      () => {
        setTimeout(() => {
          this.setState({ error: null });
        }, 3000);
      }
    );
  };

  render() {
    const { customerRequestCode } = this.state;
    const { customerId, notification, updateView } = this.props;
    return (
      <Wrapper>
        <LogoText>maintain.</LogoText>
        <br />
        <Mutation<{}, {}> mutation={VerifyCustomerCodeMutation}>
          {verifyCustomerCode => (
            <Form
              onSubmit={e => {
                e.preventDefault();
                if (this.validateForm()) {
                  this.setState({ loading: true });

                  verifyCustomerCode({
                    variables: {
                      customerId,
                      customerRequestCode
                    }
                  })
                    .then(res => {
                      this.setState({ loading: false });
                      updateView();
                      notification("Customer verified successfully");
                      window.localStorage.setItem(CUSTOMER_VERIFIED, "true");
                    })
                    .catch(err => {
                      this.setState({
                        loading: false,
                        customerRequestCode: ""
                      });
                      this.setError(
                        "You entered the wrong customer request code"
                      );
                    });
                }
              }}
            >
              <FormGroup>
                <Label for="customerCode">Enter Customer Code</Label>
                <Input
                  type="text"
                  name="customerCode"
                  value={customerRequestCode}
                  id="customerCode"
                  placeholder="Customer code"
                  onChange={this.handleChange}
                />
              </FormGroup>
              <br />
              <FormGroup>
                <Button>
                  {!this.state.loading ? <span>Verify</span> : <Loader />}
                </Button>
              </FormGroup>
              {this.state.error && (
                <p style={{ textAlign: "center", color: Colors.error }}>
                  {this.state.error}
                </p>
              )}
            </Form>
          )}
        </Mutation>
      </Wrapper>
    );
  }
}

export default CustomerRequestCodeForm;



// WEBPACK FOOTER //
// ./src/Containers/CustomerRequestPortal/CustomerRequestCodeForm.tsx